var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-fluid px-0" }, [
      _c("div", {
        staticClass: "position-absolute vh-100 w-100 top-0",
        style:
          "background-image: url('https://www.devicemagic.com/wp-content/uploads/2021/07/person_using_smartphone-1.jpg'); background-size: cover; background-position: center; filter: grayscale(80%);z-index: -1;",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-4 px-0" }, [
          _c(
            "div",
            {
              staticClass:
                "card shadow rounded-0 pt-5 overflow-auto scrollable-content",
              staticStyle: { "min-height": "737px", height: "100vh" },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-content-center align-items-center",
                  },
                  [
                    _c("div", { staticClass: "col-lg-10" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column align-items-start" },
                        [_c("img", { attrs: { src: _vm.logo, height: "65" } })]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-10" },
                      [
                        _c("router-view", { key: _vm.$route.fullPath }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-block btn-neutral mt-2",
                                attrs: {
                                  href: _vm.calculator,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Calculadora para clientes")]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center mb-5" },
                          [
                            _vm._v(
                              "\n                                    Copyright ©" +
                                _vm._s(new Date().getFullYear()) +
                                " " +
                                _vm._s(_vm.app.name) +
                                ". Todos los derechos\n                                    reservados.\n                                "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }